import { combineReducers } from 'redux';
import authReducer from './auth/authSlice';
import commonReducer from './common/commonSlice';
import conversationReducer from './conversation/conversationSlice';
import companyReducer from './company/companySlice';

const rootReducer = combineReducers({
  authReducer,
  commonReducer,
  conversationReducer,
  companyReducer,
});

export default rootReducer;
